import { TApplicationState } from '../../types/redux';
import { EMyHomeEstimationTargets } from '../../types/estimationTarget';

export const selectEstimationTarget = (state: TApplicationState): EMyHomeEstimationTargets => {
  return state.estimationTarget;
};
